export const BanyanMark = ({ className = "h-8 w-8" }) => (
  <svg
    viewBox="0 0 48 48"
    className={className}
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="1.4" />
    <path
      d="M24 35V21"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M24 23c-4.5-1-8-4.5-8-10 4.5 0 8 2.5 8 6 0-3.5 3.5-6 8-6 0 5.5-3.5 9-8 10z"
      fill="currentColor"
    />
    <path
      d="M19 35c0 2.2-1 3.4-2.2 4.4M24 35v5.5M29 35c0 2.2 1 3.4 2.2 4.4"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

export default BanyanMark;
